/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RedoOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { Drawer, Select, Input, Tooltip } from 'antd';
import styled from 'styled-components';
import { RCTable, ButtonWrapper } from 'components';
import { Box, Flex, Text } from 'atoms';
import { ACL, FilterTitle } from 'components/common';
import { getDriverList } from 'store/driverSlice';
import { getListAction } from 'store/pageSlice';
import { DriverTableConfig, DriverListQueries, initialPaginateConfig } from 'utils';
import { useQueryParams } from 'hooks';
import { FilterAtnButton } from 'utils/commonStyled';

const { Search } = Input;

const LtSearchBar = styled(Search)`
	border: none;
`;

const allOption = {
	value: '',
	label: 'All',
};

const StatusOptions = [
	{ value: 'true', label: 'Active' },
	{ value: 'false', label: 'Inactive' },
];
StatusOptions.unshift(allOption);

function populateOptions(data = [], showAll = true) {
	/**
	 * assign id & value to option list
	 */
	data = data?.map((element) => ({
		value: element?.id,
		label: element?.value,
	}));

	/**
	 * Add All option of array first
	 */
	if (showAll) {
		data.unshift(allOption);
	}

	return data;
}

export default function DriverListPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [citiesList, setCitiesList] = useState('');
	const [vendorsList, setVendorsList] = useState('');
	const [businessUnitsList, setBusinessUnitsList] = useState([]);
	const [rowData, setRowData] = useState({});
	const [paginateConfig, setpaginateConfig] = useQueryParams({
		search_type: 'driver',
		filterQuery: DriverListQueries,
	});

	useEffect(() => {
		dispatch(getListAction(paginateConfig)).then((res) => {
			let { cities = [], vendors = [] } = res;

			cities = cities?.map((element) => ({
				value: element,
				label: element,
			}));
			cities.unshift(allOption);

			vendors = populateOptions(vendors);

			setCitiesList(cities);
			setVendorsList(vendors);
		});
	}, [dispatch, paginateConfig]);

	// Fetch business units
	useEffect(() => {
		dispatch(
			getListAction({
				search_type: 'business_unit',
				limit: 100,
				offset: 0,
			})
		).then((res) => {
			const buOptions = (res?.rows || []).map((bu) => ({
				value: bu.id,
				label: bu.name,
			}));
			// Don't add "All" option for multiple select filters
			setBusinessUnitsList(buOptions);
		});
	}, [dispatch]);

	// business_unit_ids is now always an array thanks to useQueryParams transformation
	const businessUnitIds = paginateConfig?.business_unit_ids || [];

	const cityFilterValue = paginateConfig?.city ? 'City' : '';
	const StatusValue = paginateConfig?.is_active ? 'Status' : '';
	const VendorValue = paginateConfig?.vendor_id ? 'Vendor' : '';
	const businessUnitFilterValue = businessUnitIds.length > 0 ? 'Business Unit' : '';
	const StatusValueAll = paginateConfig?.is_active === '' ? 'Status' : '';
	const VendorAllValue = paginateConfig?.vendor_id === '' ? 'Vendor' : '';

	const paginationArry = [
		cityFilterValue,
		StatusValue,
		VendorValue,
		businessUnitFilterValue,
		StatusValueAll,
		VendorAllValue,
	];

	const validArray = paginationArry.filter((n) => n);
	console.log(validArray.length);

	return (
		<>
			<Flex justifyContent="space-between" mt={3}>
				<Box flex="0 0 20%">
					<LtSearchBar
						enterButton="Search"
						placeholder="Search"
						allowClear
						onSearch={(val) =>
							setpaginateConfig({
								...initialPaginateConfig,
								query_str: val,
								search_type: 'driver',
							})
						}
					/>
				</Box>
				<Box flex="0 0 35%" className="filter-hightlight">
					<Box flex="0 0 35%" display="flex">
						<FilterAtnButton
							onClick={() => {
								setOpen(true);
							}}
						>
							FILTERS
						</FilterAtnButton>
						<span className="highlight-list">
							{StatusValue && <span className="ant-tag">{StatusValue} </span>}
							{StatusValueAll && <span className="ant-tag">{StatusValueAll} </span>}
							{cityFilterValue && <span className="ant-tag">{cityFilterValue} </span>}
							{businessUnitFilterValue && (
								<span className="ant-tag" style={{ width: '100px' }}>
									{businessUnitFilterValue}
								</span>
							)}
							{VendorAllValue && <span className="ant-tag">{VendorAllValue} </span>}
							{VendorValue && <span className="ant-tag">{VendorValue} </span>}
							{validArray.length > 0 && (
								<Tooltip title="Clear filter">
									<CloseOutlined
										className="filter-close-icon"
										onClick={() => {
											window.location = `${window.origin}/drivers`;
										}}
									/>
								</Tooltip>
							)}
						</span>
					</Box>
				</Box>
				<Flex>
					<ButtonWrapper
						onClick={() =>
							setpaginateConfig({
								...initialPaginateConfig,
								search_type: 'driver',
							})
						}
						icons={<RedoOutlined />}
					>
						SYNC
					</ButtonWrapper>
					<ACL action="create" module="driver">
						<ButtonWrapper
							onClick={() => navigate('/drivers/add')}
							icons={<PlusOutlined />}
						>
							CREATE
						</ButtonWrapper>
					</ACL>
				</Flex>
			</Flex>
			<Box mt={3}>
				<RCTable
					rowKey="id"
					tableDatas={[rowData, setRowData]}
					togglePaginate={[paginateConfig, setpaginateConfig]}
					dispatchAction={getDriverList}
					columns={DriverTableConfig}
				/>
			</Box>

			<Drawer
				className="userList-drawer"
				title={<FilterTitle onClose={() => setOpen(false)} />}
				placement="right"
				closable={false}
				onClose={() => setOpen(false)}
				open={open}
			>
				<Box>
					<Box mb="2rem">
						<Text mb="5px">Status</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="status"
							value={paginateConfig?.is_active}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									is_active: val,
								}))
							}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={StatusOptions}
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">Business Unit</Text>
						<Select
							mode="multiple"
							showSearch
							style={{ width: '100%' }}
							name="business_unit_ids"
							value={businessUnitIds}
							onChange={(val) => {
								setpaginateConfig((prev) => ({
									...prev,
									business_unit_ids: val,
								}));
							}}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={businessUnitsList}
							maxTagCount="responsive"
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">City</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="city"
							value={paginateConfig?.city}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									city: val,
								}))
							}
							allowClear
							onClear={() => {
								setpaginateConfig((prev) => ({
									...prev,
									city: '',
									client_id: undefined,
									project_id: '',
									vendor_id: '',
									trip_type: '',
								}));
							}}
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={citiesList}
						/>
					</Box>
					<Box mb="2rem">
						<Text mb="5px">Vendor</Text>
						<Select
							showSearch
							style={{ width: '100%' }}
							name="vendor_name"
							value={paginateConfig?.vendor_name}
							onChange={(val) =>
								setpaginateConfig((prev) => ({
									...prev,
									vendor_id: val,
								}))
							}
							allowClear
							filterOption={(input, option) =>
								option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Select"
							options={vendorsList}
						/>
					</Box>
					<Box>
						{/* <ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() =>
								setpaginateConfig((prev) => ({
									...prev,
									user_type: 'admin',
								}))
							}
						>
							RESET FILTERS
						</ButtonWrapper> */}
						<ButtonWrapper
							marginLeft="auto"
							border="1px solid rgba(237, 108, 2, 0.5)"
							color="#ed6c02"
							onClick={() => {
								// navigate('/client-list');
								window.location = `${window.origin}/drivers`;
							}}
						>
							RESET FILTERS
						</ButtonWrapper>
					</Box>
				</Box>
			</Drawer>
		</>
	);
}
